import React from 'react';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { ServiceService } from 'services';
import { Globals } from 'utils';
import { Input } from 'components';

interface Props {
	onClose?: any;
}

class ModalUrgent extends React.Component<Props> {

	state = {
		urgent_prices: []
	}

	componentDidMount() {
		this.load();
	}

	load = async () => {
		const res: any = await ServiceService.admin.getUrgent();
		this.setState({
			urgent_prices: res.urgent_prices
		});
	}

	submit = async () => {
		if (this.state.urgent_prices.map((i: any) => i.price).filter((i: any) => !i).length > 0) {
			Globals.showError("Debe ingresar todos los precios para continuar");
			return;
		}
		if (this.state.urgent_prices.map((i: any) => i.price_corporate).filter((i: any) => !i).length > 0) {
			Globals.showError("Debe ingresar todos los precios para continuar");
			return;
		}
		await ServiceService.admin.setUrgent({
			urgent_prices: JSON.stringify(this.state.urgent_prices)
		});
		this.props.onClose();
		Globals.showSuccess("Se ha modificado el precio del servicio urgente");
	}

	render() {
		const urgent_prices: any = this.state.urgent_prices;

		return (
			<div id="modal-service-urgent">
				<div className="container-prices">
					<div className="row">
						{
							this.state.urgent_prices.map((item: any,index: number) => {
								return (
									<React.Fragment>
										<div className="col-4">
											<p>Hasta { item.until }m<sup>2</sup></p>
										</div>
										<div className="col-8">
											<div className="container-inputs">
												<Input
													type="decimal"
													color="white"
													value={ item.price }
													placeholder="Precio"
													onChange={ (e: any) => {
														let areas: any = [...this.state.urgent_prices];
														urgent_prices[index].price = e.target.value;
														this.setState({
															areas
														});
													} } />
												<Input
													type="decimal"
													color="white"
													value={ item.price_corporate }
													placeholder="Precio Corporativo"
													onChange={ (e: any) => {
														let areas: any = [...this.state.urgent_prices];
														urgent_prices[index].price_corporate = e.target.value;
														this.setState({
															areas
														});
													} } />
											</div>
										</div>
									</React.Fragment>
								)
							})
						}
					</div>
				</div>
				<div className="row">
					<div className="col-6 text-center">
						<button className="btn btn-cancel" onClick={ () => this.props.onClose() }>
							Cerrar
						</button>
					</div>
					<div className="col-6 text-center">
						<button className="btn btn-save" onClick={ () => this.submit() }>
							Guardar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalUrgent;